<template>
    <div class="insight-data-landing-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                  Telesales - lead generation in partnership with Insight Data
                </div>
                <div class="logo">
                    <img src="/images/insight-data-logo-small.png">
                </div>
            </div>
            <div class="box-1">
                <h1>10% discount on telesales campaigns over £500.</h1>
              <p>
                Insight Data has a state-of-the-art call centre and experienced telemarketing team operating to the highest standards.
              </p>
              <p>
                The team are given extensive product and industry training upon employment with Insight Data to produce phenomenal results and will manage the whole campaign for you from script creation to implementation, documenting all leads generated.
              </p>
              <p>
                An easy-to-read report will be supplied upon completion to show your campaign results.
              </p>
            </div>
            <div class="overlapping-image">
                <img src="/images/offers-and-promotions-telesales-lead-generation-header.png">
            </div>
            <div class="box-2">
                <p>
                  Receive a 10% discount on telesales campaigns over £500.
                </p>
                <p>
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </p>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Email Marketing Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some more information on Telesales - lead generation',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 32,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Telesales - lead generation enquiry',
                'value': 'Telesales - lead generation enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Insight Data Telesales - lead generation`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Insight Data Telesales - lead generation partner link clicked',
          'value': 'Insight Data Telesales - lead generation partner link clicked',
        });
      },
    },
};
</script>
